import React from 'react'
import PropTypes from 'prop-types'

import { Card, List } from 'semantic-ui-react'

import CardProperty from 'Components/CardProperty'
import Permissions from 'Components/Permissions'

import * as rugHelpers from 'Global/Helpers/rugHelpers'
import { getFormattedDateString } from 'Global/Helpers/timeHelpers'

const RugCardStatus = ({ noRibbon, rug }) => {
  if (rug.advisor || rug.belCustomer) {
    return (
      <Permissions
        permissions={['rug.field.advisor', 'rug.field.status', 'rug.field.belCustomer']}
        render={() => (
          <Card.Content extra>
            <List>
              {rug.advisor && (
                <Permissions
                  permissions="rug.field.advisor"
                  render={() => (
                    <CardProperty icon="spy" popUpContent="Advisor">
                      {rug.advisor}
                    </CardProperty>
                  )}
                />
              )}

              {noRibbon && (
                <Permissions
                  permissions="rug.field.status"
                  render={() => (
                    <CardProperty icon="shopping basket" popUpContent="Status">
                      {rugHelpers.getStatus(rug).text}
                    </CardProperty>
                  )}
                />
              )}

              {rug.belCustomer && (
                <Permissions
                  permissions="rug.field.belCustomer"
                  render={() => (
                    <CardProperty icon="user" popUpContent={`Invoice Date: ${getFormattedDateString(rug.belRgDate)}`}>
                      {rug.belCustomer}
                    </CardProperty>
                  )}
                />
              )}
            </List>
          </Card.Content>
        )}
      />
    )
  }

  return null
}

RugCardStatus.propTypes = {
  noRibbon: PropTypes.bool.isRequired,
  rug: PropTypes.object.isRequired,
}

export default RugCardStatus
